import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTheme } from 'glamorous';
import ValidatedInput from '../../../../../../../common/components/ValidatedInput';
import CurrentUserActions from '../../../../../../../redux-modules/current-user';
import CustomerActions from '../../../../../../../redux-modules/customers';
import OrganizationActions from '../../../../../../../redux-modules/organizations';
import { withLoading } from '../../../../../../../redux-modules/loading-overlay';
import {
  IdentificationForm,
  SubmitButton,
  ConfirmText,
  ConfirmButton,
} from './styles';

class UserIdentification extends React.Component {
  static propTypes = {
    actions: PropTypes.shape({
      customer: PropTypes.object,
      user: PropTypes.object,
    }),
    event: PropTypes.shape({
      color: PropTypes.string,
    }),
    theme: PropTypes.shape({
      color: PropTypes.string,
    }),
  };
  static promises = {
    includePromises: [
      {
        type: 'ENTITY/ENTITY_GET',
        meta: { namespace: 'customers' },
      },
    ],
  };
  state = {
    email: '',
    isConfirming: false,
    errors: { request: {} },
    serverError: false,
  };

  handleOnChange = email => {
    return this.setState(prevState => ({
      email,
      errors: { ...prevState.errors, email: '' },
      isConfirming: false,
    }));
  };

  handleOnBlur = (evt, { isValid = true, message = '' }) => {
    if (!isValid) {
      return this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          email: message,
        },
      }));
    }
  };

  handleErrors = results => {
    const { payload: { resp = {} } = {} } = results || {};

    if (resp.status === 404) {
      return this.setState({ isConfirming: true });
    }

    if (resp.status >= 500 && resp.status < 600) {
      return this.setState({ serverError: true });
    }
  };

  handleSubmit = evt => {
    evt.preventDefault();
    const { email, isConfirming } = this.state;
    const { actions } = this.props;

    if (isConfirming) {
      // set email so we can create user during registration
      return actions.user.updateSettings({ email });
    }

    return actions.customer
      .get(null, { params: { email } })
      .catch(this.handleErrors)
      .then(results => {

        const {
          payload: {
            resp = {},
            json: {
              key: customerKey,
              organization,
            } = {}
          } = {}
        } = results || {};

        if (!resp.ok) {
          return this.handleErrors(results);
        }

        if (organization && organization.key) {
          actions.organization.get(organization.key);
        }

        // set id so we can fetch customer (pull request fix)
        return actions.user.setId(customerKey);
      });
  };

  render() {
    const { theme: { color } = {} } = this.props;
    const { email, errors, isConfirming } = this.state;
    const eventFull = sessionStorage.getItem("engage-eventfull");
    if (eventFull != null && eventFull === "true") {
      return (
        <p id="thanksMessage">
          Thank you for your interest in this NFIB event.
    <br />
          Currently, no seats are available.
     <br />
          If you have questions, please contact NFIB by calling the number provided in the event description or 1-800-NFIB-NOW.
  </p>
      );
    } else if (eventFull === "false")
      return (
        <IdentificationForm onSubmit={this.handleSubmit}>
          <p>
            Please enter your email address to register for this event.<br />
            If you have an existing NFIB account, please use the email address
            associated with that account.
        </p>
          <ValidatedInput
            validation={[
              {
                pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/i,
                message: 'Not a valid email address',
                events: ['onBlur'],
              },
            ]}
            type="email"
            label="Email Address"
            value={email}
            onChange={this.handleOnChange}
            onBlur={this.handleOnBlur}
            error={errors.email}
          />
          <SubmitButton
            disabled={!email.length || (!!errors.email && !!errors.email.length)}
            label="Submit"
            type="submit"
            backgroundColor={color}
            isConfirming={isConfirming}
          />
          <ConfirmText isConfirming={isConfirming}>
            We do not have a record of this email address. Is this email correct?
        </ConfirmText>
          <ConfirmButton
            isConfirming={isConfirming}
            raised
            type="submit"
            label="Confirm"
          />
        </IdentificationForm>
      );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      customer: bindActionCreators(CustomerActions, dispatch),
      user: bindActionCreators(CurrentUserActions, dispatch),
      organization: bindActionCreators(OrganizationActions, dispatch),
    },
  };
};

export default connect(null, mapDispatchToProps)(
  withTheme(withLoading(UserIdentification))
);



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/Availability/UserIdentification/index.js